import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	hideConsumptionEmissionEngineName: true,
	useStaticPriceDateRemark: true,
	enablePriceDisclaimer: true,
};
